module.exports = __webpack_public_path__ + "img/5.d90a6da3.png";